import { format } from "date-fns";

export function formatTime(hour: number, minute: number, formatStr = "hh:mm a"): string {
    const date = new Date();

    date.setHours(hour);
    date.setMinutes(minute);

    return format(date, formatStr);
}

export function formatDuration(seconds: number): string {
    const days = Math.floor(seconds / (3600 * 24));
    const hours = Math.floor((seconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const ss = seconds % 60;

    const pad = (num: number) => String(num).padStart(2, "0");

    const hhmmss = `${pad(hours)}:${pad(minutes)}:${pad(ss)}`;

    if (days > 0) return `${pad(days)}:${hhmmss}`;

    return hhmmss;
}
